import { SegmentedControl } from '../../atoms';

type Period = {
  id: string;
  text: string;
  textPrefix?: string;
  textSuffix?: string;
  disabled?: boolean;
};

export type PrepaySelectProps = {
  periods: Period[];
  selectedPeriodId: string;
  onPeriodSelect: (selectedPeriodId: string) => void;
  disabled: boolean;
};

export const PrepaySelect = ({ periods, selectedPeriodId, onPeriodSelect, disabled }: PrepaySelectProps) => (
  <SegmentedControl
    fullWidth
    fixedHeight
    options={periods.map((period) => ({
      value: period.id,
      label: (
        <div className="period-option">
          {period.textPrefix && <div className="period-option__period-prefix">{period.textPrefix}</div>}
          <div className="period-option__period">{period.text}</div>
          {period.textSuffix && <div className="period-option__period-suffix">{period.textSuffix}</div>}
        </div>
      ),
      disabled: period.disabled || disabled,
    }))}
    onValueChange={onPeriodSelect}
    value={selectedPeriodId}
  />
);
